export function Loading() {
    return <div className="flex-center">
        <div className="loading">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>;
}
